
import { defineComponent, getCurrentInstance, toRefs, ref, reactive, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from '@/store/index'
import { CouponShape, CouponType, CouponStatus, CouponActiveStatus } from '@/enums/coupon'
import { joinParams } from '@/utils'
import { getCouponList, getActivationList, getCancelList, getSoldList, getSoldLog, saveCheck, cancelCoupon, checkActivation,onPowerApi } from '@/apis/coupon'
import { getCompanyListApi } from '@/apis/merchant'
import { getSaleChannelList } from '@/apis/channel'
import { getSaleList } from '@/apis/admin'
import Pagination  from '@/components/Pagination.vue'
import Keys from '@/constant/key'

enum ActionTypes {
    '编辑' = 'onSave()',
    '激活' = 'onActive()',
    '驳回' = 'onActive()',
    '作废' = 'onCancel()',
    '批量修改' = 'onSave()',
    '权限修改' = 'onPower()',

}
interface ruleTitle {
    id:     number,     // ID
    name:   string,     // 名称
}
export default defineComponent({
name: 'CouponList',
components: { Pagination },
setup() {
    const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const userGroups = store.state.user.userInfo.group_id.split(',')
    
    const pageType:any = route.meta.title   // 当前页面类型：卡券列表（通过query.id-券包ID获取卡券）、激活列表、作废列表
    const state = reactive({
        filters: {
            coupon_id:          route.query.id || null,   // 券包 ID
            ids:                '',     // 当前操作券包ID
            start_id:           '',     // 券码开始 ID
            end_id:             '',     // 券码结束 ID
            batch:              '',     // 批次号
            status:             '',     // 券码状态
            page:               1,      // 页码
            page_size:          10,     // 每页显示条数
            salesman_id:        '',     // 销售人员 ID
            sale_channel_id:    undefined,  // 销售渠道 ID
            start_actived_at:   '',     // 卡激活开始时间
            end_actived_at:     '',     // 卡激活结束时间
            start_created_at:   '',     // 卡生成开始时间
            end_created_at:     '',     // 卡生成结束时间
            start_date:         '',     // 卡生成开始时间
            end_date:           '',     // 卡生成结束时间
        },
        tableData:          [],     // 表格数据
        total:              0,      // 表格总条数
        selectedList:       [],     // 选中卡券
        
        dialogVisible:      false,  // 弹框
        noticeDialog:    false,  // 关卡弹框
        actionType:         '',     // 当前操作类型：编辑、激活、驳回、作废
        companyList:        [],     // 公司列表
        saleList:           [],     // 销售人员列表
        saleChannelList:    [],     // 销售渠道列表
        saleListProps:      {
            label: 'company_all',
            value: 'id'
        },
        props:{
            expandTrigger: 'hover',
            value:'id',
            label:'name',
            multiple: true,
            checkStrictly: true,
        },
        options:[],
        powerName:false,
        validYears: Array.from({ length: 10 }, (_, index) => index +1), // 生成1到10的年份数组
        // couponList:[],
        formData: {
            id:                 '',     // 当前券码 ID
            ids:                '',     // 当前券码 ID（与 id，字段一致，列表返回字段名是 id，保存提交时上传参数为 ids）
            coupon_id:          '',     // 当前券包 ID
            company_name:       '',     // 公司名称
            sale_channel:       '',     // 销售渠道
            salesman_id:        '',     // 销售人员 ID
            coupon_type:        '',     // 券包形式
            charge_coupon_type: '',     // 券包类型
            coupon_attribute:   '',     // 券包属性
            // coupon_attribute:   [],     // 券包属性
            amount:             '',     // 面值
            coupon_discount:    '',     // 结算折扣
            count:              '',     // 数量
            card_no:            '',     // 前缀
            valid_from:         '',     // 开始有效期
            valid_to:           '',     // 结束有效期
            activation:         1,      // 是否申请激活
            user_coupon_ids:    '',     // 当前选中券码
            rule_title:         '',     // 卡券名称
            movie_type:         '',     // 是否加电影服务费：1-是，2-否
            rule_id:            '',     // 卡券id
            use_rule:           [],     // 使用权限
            buy_rule:           [],     // 购买权限
            valid_term:         0,      // 蛋糕余额有效期
            bind_term:          36,     // 出卡有效期
        },
        cardData: {
            quantity: '',     // 卡券数量
            untied_card_count: '',     // 未绑定数量
            untied_card_amount: '',     // 未绑定金额
            already_card_count: '',     // 已绑定数量
            already_card_amount : '',     // 已绑定金额
        },
        buyRule:            [],     // 购买权限接口返回
        remark:                 '',     // 驳回原因
        msg:                    '',     // 作废原因
    })
    const couponPowerList = ref<ruleTitle[]>([])
    
        
    // 获取表格数据
    const getList = async () => {
        let res:any = {}
        switch (pageType) {
            case '卡券列表':
                res = await getCouponList(state.filters) as any
                break
            case '卡券激活列表':
                res = await getActivationList(state.filters) as any
                break
            case '卡券作废列表':
                res = await getCancelList(state.filters) as any
                break
            case '卡券销售列表':
                res = await getSoldList(state.filters) as any
                break
            case '卡券销售记录':
                res = await getSoldLog(state.filters) as any
                break
        }
        const { code, data, msg } = res
        if (code != 200) {
            return proxy.$message({ type: 'error', message: msg })
        }
        state.tableData = data.data
        state.total = data.total
    }
    // 搜索
    const onSearch = () => {
        state.filters.page = 1
        getList()
    }
    // 获取公司列表
    const onGetCompanyList = async () => {
        const { code, data, msg } = await getCompanyListApi() as any
        if (code != 0) return proxy.$message({ type: 'error', message: msg })
        state.companyList = data
    }
    // 获取销售渠道列表
    const onGetSaleChannelList = async () => {
        const { code, data, msg } = await getSaleChannelList() as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        state.saleChannelList = data
    }
    // 公司搜索联想
    const onCompanySearch = (queryString, cb) => {
        const results = queryString ? state.companyList.filter((item:any) => item.name.indexOf(queryString)>-1) : state.companyList
        cb(results)
    }
    // 销售渠道搜索联想
    const onSaleChannelSearch = (queryString, cb) => {
        const results = queryString ? state.saleChannelList.filter((item:any) => (item.company_all && item.company_all.indexOf(queryString)>-1)) : state.saleChannelList
        cb(results)
    }
    // 获取销售人员列表
    const onGetSaleList = async () => {
        const { code, data, msg } = await getSaleList() as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        state.saleList = data
    }
    // 选中数据监听
    const onSelectionChange = (val) => {
        state.selectedList = val
    }
    // 批量修改
    const onBatchEdit = async () => {
        getPower()//获取权限列表
        
        const { code, data, msg, info } = await checkActivation(state.filters) as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        state.actionType = '批量修改'
        info.use_rule = info.use_rule || []
        info.buy_rule = info.buy_rule || []
        state.formData = info
        if(info.bind_term==0||info.bind_term==null){
            state.formData.bind_term = 36
        }
        proxy.$refs.couponEditForm && proxy.$refs.couponEditForm.clearValidate()
        state.dialogVisible = true
    }
    // 批量导出
    const onExport = () => {
        let exportUrl = ''
        switch (pageType) {
            case '卡券销售列表':
                exportUrl = '/admin/coupons/exportCouponSaleData'
                break
            case '卡券销售记录':
                exportUrl = '/admin/coupons/exportCouponSaleDataLog'
                break
            default:
                exportUrl = '/admin/coupons/exportUserCouponsData'
        }
        window.open(Keys.baseUrl + exportUrl + '?' + joinParams({...state.filters, user_id:store.state.user.userInfo.id}))
    }
    // 根据卡券名匹配相应的权限
    const onRuleTitleChange = (id) => {
        state.formData.buy_rule =state.buyRule[id]
    }
    // 显示弹框：变量重新赋值
    const beforeDialogOpen = (row:any, action:string) => {
        if(action==='权限修改'){
            const {filters} = state
            onPowerApi({...filters,info:row}).then((result) => {
                const { code, data, msg } = result as any;
                if (code != 200) return proxy.$message({ type: 'error', message: msg })
                getPower()//获取权限列表
                state.actionType = action
                state.dialogVisible = true
                data.use_rule = data.use_rule || []
                data.buy_rule = data.buy_rule || []
                state.formData = data
                //如果卡券名是自定义的
                //@ts-ignore
                if(state.formData.rule_id ==0) {
                    state.powerName = true
                }
            });
            
        }else {
            row.use_rule = row.use_rule || []
            row.buy_rule = row.buy_rule || []
            state.formData = { ...row }
            // @ts-ignore
            // if (state.formData.company_id === 0) state.formData.company_id = ''
            // @ts-ignore
            // if (state.formData.sale_channel_id === 0) state.formData.sale_channel_id = ''
            getPower()//获取权限列表
            // @ts-ignore
            if (state.formData.salesman_id === 0) state.formData.salesman_id = ''
            if (action==='编辑') {
                state.formData.activation = 1
                if(row.bind_term==0||row.bind_term==null){
                    state.formData.bind_term = 36
                }
            }
            state.actionType = action
            state.dialogVisible = true
        }
    }
    const ChangeBind = () => {
        if(state.formData.bind_term > 36 || state.formData.bind_term == 0){
            state.formData.bind_term = ''
        }
        if(state.formData.valid_term!=0){
            state.formData.valid_term = ''
        }
    }
    //获取权限列表
    const getPower = () => {
        proxy.$http.get('/admin/coupons/getCouponRuleData').then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            couponPowerList.value = data.rule_title
            state.options = data.rule_list
            //@ts-ignore
            state.buyRule = data.buy_rule
        })
    }
    
    // 校验卡券名称是否占用预设名称
    const checkPowerName = () => {
        const sameIndex = couponPowerList.value.findIndex(item => item.name === state.formData.rule_title)
        if (sameIndex > -1) {
            proxy.$message({ type: 'error', message: '该名称为预设名称，不可使用' })
            state.formData.rule_title = ''
        }
    }
    // 清空弹框数据
    const beforeDialogClose = () => {
        state.remark = ''
        state.msg = ''
        state.selectedList = []
        proxy.$refs.couponList.clearSelection()
        state.formData = {
            id:                 '',     // 当前券码 ID
            ids:                '',     // 当前券码 ID（与 id，字段一致，列表返回字段名是 id，保存提交时上传参数为 ids）
            coupon_id:          '',     // 当前券包 ID
            company_name:       '',     // 公司名称
            sale_channel:       '',     // 销售渠道
            salesman_id:        '',     // 销售人员 ID
            coupon_type:        '',     // 券包形式
            charge_coupon_type: '',     // 券包类型
            coupon_attribute:   '',     // 券包属性
            amount:             '',     // 面值
            coupon_discount:    '',     // 结算折扣
            count:              '',     // 数量
            card_no:            '',     // 前缀
            valid_from:         '',     // 开始有效期
            valid_to:           '',     // 结束有效期
            activation:         1,      // 是否申请激活
            user_coupon_ids:    '',     // 当前选中券码
            rule_title:         '',     // 卡券名称
            rule_id:            '',     // 卡券id
            use_rule:           [],     // 使用权限
            buy_rule:           [],     // 购买权限
            valid_term:         '',     // 蛋糕余额有效期
            bind_term:          '',     // 绑定卡有效期

        },
        state.dialogVisible = false
    }
    // 执行相应的方法
    const onSubmit = () => {
        eval(ActionTypes[state.actionType])
    }
    // 打开关卡弹窗
    const openCardDialog = () => {
        proxy.$http.get('/admin/coupons/closeCouponSaleList', {is_check:1,...state.filters}).then(res => {
            const { code, data, msg } = res
            if (code == 200) {
                // proxy.$message({ type: 'success', message: msg }) 
                Object.assign(state.cardData, data)
                state.noticeDialog = true
            } else {
                proxy.$message({ type: 'error', message: msg }) 
            }
        })
    }
    // 关闭关卡弹窗
    const closeCardDialog = () => {
        state.noticeDialog = false
        state.cardData.quantity = ''
        state.cardData.untied_card_amount = ''
        state.cardData.already_card_amount = ''
    }
    const switchCard = () => { 
        proxy.$http.post('/admin/coupons/closeCouponSaleList', {is_check:0,...state.filters}).then(res => {
            const { code, data, msg } = res
            if (code == 200) {
                proxy.$message({ type: 'success', message: msg }) 
                closeCardDialog()
                getList()
            } else {
                proxy.$message({ type: 'error', message: msg }) 
            }
        }) 
    }
    //权限修改
    const onPower = () => {
        proxy.$refs['couponEditForm'].validate((valid:boolean) => {
            if (valid) {
                const { formData, filters } = state
                //当用户进行选择时，即点击返回时
                if(state.powerName == false) {
                    //@ts-ignore
                    delete formData.use_rule
                } 
                if(state.powerName == false) {
                    let matchingCoupon = couponPowerList.value.find(coupon => coupon.id === state.formData.rule_title);
                    if (matchingCoupon) {
                        state.formData.rule_title = matchingCoupon.name;
                    }
                }
                // @ts-ignore
                if(!formData.rule_title){
                    return proxy.$message({ type: 'error', message: '请输入卡券名称' })
                }
                // @ts-ignore
                if(formData.buy_rule.length === 0){
                    return proxy.$message({ type: 'error', message: '请选择商城购买权限' })
                }
                // @ts-ignore
                // if(state.powerName === true && !formData.use_rule.length){
                //     return proxy.$message({ type: 'error', message: '请输入卡券购买权限' })
                // }
                if(formData.valid_term!=0){
                    formData.valid_term = formData.bind_term
                }
                formData.ids = formData.id   
                proxy.$http.post('/admin/coupons/saveCouponRule', {...formData, ...filters}).then((res:any) => {
                    const { code, data, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '保存成功' })
                    beforeDialogClose()
                    getList()
                })
            }
        })
    }
    // 保存编辑
    const onSave = () => {
        proxy.$refs['couponEditForm'].validate((valid:boolean) => {
            if (valid) {
                const { formData, filters } = state
                 //当用户进行选择时，即点击返回时
                if(state.powerName == false) {
                    //@ts-ignore
                    delete formData.use_rule
                } 
                if(state.powerName == false) {
                    let matchingCoupon = couponPowerList.value.find(coupon => coupon.id === state.formData.rule_title);
                    if (matchingCoupon) {
                        state.formData.rule_title = matchingCoupon.name;
                    }
                }
                //@ts-ignore
                // if(state.powerName === true && !formData.use_rule){
                //     return proxy.$message({ type: 'error', message: '请输入卡券购买权限' })
                // }
                formData.ids = formData.id

                // 购买权限必须包含蛋糕品类，且卡券购买权限(use_rule)完成等于商城购买权限
                const buy_rule:any = formData.buy_rule?.flat(2);
                if (!buy_rule.includes('1')) {
                    return proxy.$message({ type: 'error', message: '商城购买权限必须包含蛋糕品类' })
                }
                formData.use_rule = formData.buy_rule;

                proxy.$http.post('/admin/coupons/applyActivation', {...formData, ...filters}).then((res:any) => {
                    const { code, data, msg } = res
                    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                    proxy.$message({ type: 'success', message: '保存成功' })
                    beforeDialogClose()
                    getList()
                })
            }
        })        
    }
    // 保存审核
    const onActive = () => {
        const { actionType, remark } = state
        if (actionType === '激活') {
            proxy.$refs['couponEditForm'].validate((valid:boolean) => {
                if (valid) {
                    proxy.$confirm('确定要激活此批次券码，并自动生成批次吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        onSaveCheck(1)
                    }).catch(() => {
                        console.log('取消激活')
                    })
                }
            })
        } else {
            if (!remark) return proxy.$message({ type: 'error', message: '请输入驳回原因' })
            onSaveCheck(2, remark)
        }
    }
    // 保存审核结果
    const onSaveCheck = async (status:number, remark:string = '') => {
        // @ts-ignore
        delete state.formData.user_coupon_ids // 删除券码字段（后端不需要些字段）
        const { code, data, msg } = await saveCheck({ ...state.formData, status, remark }) as any
        if (code != 200) return proxy.$message({ type: 'error', message: msg })
        proxy.$message({ type: 'success', message: '保存成功' })
        beforeDialogClose()
        getList()
    }
    // 判断当前行是否可进行作废操作
    const checkCancelable = (row) => {
        return !(CouponStatus[row.status]!=='已激活' || row.owner_id > 0)
    }
    // 保存作废
    const onCancel = async () => {
        const { msg, formData, selectedList } = state
        if (!msg) {
            return proxy.$message({ type: 'error', message: '请输入作废原因' })
        }
        let ids:Array<string> = []
        if (formData.id) {
            ids.push(formData.id)
        } else if (state.filters.ids) {
            ids = state.filters.ids.split(',')
        } else {
            ids = selectedList.map((item:any) => item.id)
        }

        const { code, data, msg:resMsg } = await cancelCoupon({ ...state.filters, ids: ids.join(','), msg }) as any
        if (code != 200) return proxy.$message({ type: 'error', message: resMsg })
        proxy.$message({ type: 'success', message: '保存成功' })
        beforeDialogClose()
        getList()
    }
    // 批量作废
    const onBatchCancel = () => {
        // const { selectedList } = state
        // if (selectedList.length===0) {
        //     return proxy.$message({ type: 'error', message: '请至少选择一张作废卡券' })
        // }
         
        state.actionType = '作废'
        state.dialogVisible = true
    }
    // 分页
    const onPageChange = (val:number) => {
        state.filters.page = val
        getList()
    }
    // 每页显示条数
    const onSizeChange = (val) => {
        state.filters.page_size = val
        getList()
    }

    // 券包属性校验：当券包形式为实体卡时，此字段必填
    const attrValidator = (rule:any, value:any, callback:any) => {
        const { coupon_type } = state.formData
        if (coupon_type=='1' && value==null) {
            callback(new Error('请选择券包属性'))
        } else {
            callback()
        }
    }
    // 不得大于 100
    const max100 = (rule:any, value:any, callback:any) => {
        if (value > 100) {
            callback(new Error('结算折扣不得大于100'))
        } else {
            callback()
        }
    }
    // 表单校验规则
    const rules = reactive({
        company_name: [
            { required: true, message: '请选择公司', trigger: 'change' }
        ],
        sale_channel: [
            { required: true, message: '请选择渠道名称', trigger: 'change' }
        ],
        salesman_id: [
            { required: true, message: '请选择销售人员', trigger: 'change' }
        ],
        coupon_type: [
            { required: true, message: '请选择券包形式', trigger: 'change' }
        ],
        charge_coupon_type: [
            { required: true, message: '请选择券包类型', trigger: 'change' }
        ],
        coupon_attribute: [
            { validator: attrValidator, trigger: 'change' }
        ],
        amount: [
            { required: true, message: '请输入面值', trigger: 'blur' }
        ],
        coupon_discount: [
            { required: true, message: '请输入结算折扣', trigger: 'blur' },
            { validator: max100, trigger: 'blur' }
        ],
        count: [
            { required: true, message: '请输入数量', trigger: 'blur' }
        ],
        card_no: [
            { required: true, message: '请输入卡号前缀', trigger: 'blur' }
        ],
        valid_from: [
            { required: true, message: '请选择有效期开始时间', trigger: 'change' }
        ],
        valid_to: [
            { required: true, message: '请选择有效期结束时间', trigger: 'change' }
        ],
        activation: [
            { required: true, message: '请选择申请激活', trigger: 'change' }
        ],
        // rule_title: [
        //     { required: true, message: '请输入卡券名', trigger: 'change' }
        // ],
        // buy_rule: [
        //     { required: true, message: '请选择购买权限', trigger: 'change' }
        // ],
        movie_type: [
            { required: true, message: '请选择是否加电影服务费', trigger: 'change' }
        ],
        valid_term: [
            { required: true, message: '请选择蛋糕余额有效期', trigger: 'change' }
        ],
        bind_term: [
            { required: true, message: '请选择出卡有效期', trigger: 'change' }
        ],
    })

    onGetCompanyList() // 获取公司列表
    onGetSaleChannelList() // 获取销售渠道列表
    onGetSaleList() // 获取销售人员列表
    const now = new Date()
    const firstDay =new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1))
    state.filters.start_actived_at = firstDay.toISOString().slice(0, 10)
    state.filters.end_actived_at = now.toISOString().slice(0, 10)
    // 券包属性：通用卡与定制卡互斥判断逻辑，两者只能二选一
    // watch(() => state.formData.coupon_attribute, (newVal, oldVal:any) => {
    //     const idx1 = newVal.findIndex(item => item == '1')
    //     const idx2 = newVal.findIndex(item => item == '2')
    //     if (idx1>-1 && idx2>-1) {
    //         oldVal.includes('1') && state.formData.coupon_attribute.splice(idx1, 1)
    //         oldVal.includes('2') && state.formData.coupon_attribute.splice(idx2, 1)
    //     }
    // })
    watch(() => route.path, (newVal, oldVal) => {
        location.reload()
    })
    watch(() => state.powerName, (newVal, oldVal) => {
        if (oldVal === false && newVal === true) {
            // 从选择模式切换到特殊配置模式，清空 rule_title
            if(typeof state.formData.rule_title === 'number'){
                //@ts-ignore
                const matchingCoupon = couponPowerList.value.find(coupon => coupon.id === state.formData.rule_title);
                if (matchingCoupon) {
                    //@ts-ignore
                    state.formData.rule_title = matchingCoupon.name;
                }else {
                    state.formData.rule_title = '';
                }
            }
            
        } else if (oldVal === true && newVal === false) {
            // 从特殊配置模式切换到选择模式，尝试从 couponPowerList 中查找匹配的id值
            //@ts-ignore
            const matchingCoupon = couponPowerList.value.find(coupon => coupon.id === state.formData.rule_id);
            if (matchingCoupon) {
                //@ts-ignore
                state.formData.rule_title = matchingCoupon.id;
            } else {
                // 如果找不到匹配项，将 rule_title 清空
                state.formData.rule_title = state.formData.rule_title;
            }
        }
    })
    if (state.filters.coupon_id || pageType==='卡券激活列表') getList()
    return { pageType, store, ...toRefs(state), ActionTypes, CouponShape, CouponType, CouponStatus, CouponActiveStatus, rules, onPageChange, onSizeChange, beforeDialogOpen, beforeDialogClose, checkCancelable, onExport, onBatchEdit, onSubmit, onSelectionChange, onSearch, onBatchCancel, onSaleChannelSearch, onCompanySearch,getPower,couponPowerList,onRuleTitleChange,ChangeBind,router,switchCard,openCardDialog,closeCardDialog,userGroups,checkPowerName }
}
})
